import { createAction } from '@reduxjs/toolkit';
import { AgentMessage, ChatAgentSession, ErrorObject } from 'types';
import { AppendEventResponseData } from 'utils/socket';

export const initAgentSession = createAction<{ agentSessionId: string; investigationId: string }>(
  'AGENT_SESSIONS/INIT_SESSION'
);
export const initAgentSessionRequest = createAction('AGENT_SESSIONS/INIT_SESSION_REQUEST');
export const initAgentSessionSuccess = createAction<{ sessionId: string }>(
  'AGENT_SESSIONS/INIT_SESSION_SUCCESS'
);
export const initAgentSessionFailure = createAction<ErrorObject>(
  'AGENT_SESSIONS/INIT_SESSION_FAILURE'
);

export const updateAgentSession = createAction<AppendEventResponseData>(
  'AGENT_SESSIONS/UPDATE_SESSION'
);

export const sendMessageAgentSession = createAction<{ message: string }>(
  'AGENT_SESSIONS/SEND_MESSAGE'
);

export const sendMessageAgentSessionRequest = createAction<{ message: string }>(
  'AGENT_SESSIONS/SEND_MESSAGE_REQUEST'
);
export const sendMessageAgentSessionSuccess = createAction<{ message: AgentMessage }>(
  'AGENT_SESSIONS/SEND_MESSAGE_SUCCESS'
);

export const setInitialResponse = createAction<ChatAgentSession>(
  'AGENT_SESSIONS/SET_INITIAL_RESPONSE'
);

export default sendMessageAgentSession;
